import { LazyImport, LazyModule } from 'owa-bundling';
import { ComponentClass } from 'react';
export { ComponentClass };

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "AttachmentSuggestions" */ './lazyIndex')
);

// Lazy exports
export const lazyGetAttachmentSuggestionsAction = new LazyImport(
    lazyModule,
    m => m.getAttachmentSuggestionsAction
);

export const lazyCreateCloudFileFromAttachmentData = new LazyImport(
    lazyModule,
    m => m.createCloudFileFromAttachmentData
);

// Synchronous exports
export { default as getMRUAttachmentStore } from './store/mruAttachmentStore';
